import React from 'react'
import Image from '../images/quetta.jpg'

const Quetta = () => {
    return (
        <div className='cities'>
            <div className="container">
                <div className="row">
                    <div className="col-md-6">
                    <div className="c_img">
                        <img src={Image} alt="Quetta" className='city_img' />
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="cities_inner">
                        <h1>Quetta</h1>
                        <p>Quetta formerly known as Shalkot is the provincial capital and largest city of the Pakistani province of Balochistan.
                             It is also the 10th largest city in Pakistan.[4] It was largely destroyed in the 1935 Quetta earthquake, but was rebuilt
                              and has a population of 1,001,205 according to the census of 2017. Quetta is at an average elevation of 1,680 metres (5,510 feet)
                               above sea level, making it Pakistan's only high-altitude major city. The city is known as the "Fruit Garden of Pakistan,"
                                due to the numerous fruit orchards in and around it, and the large variety of fruits and dried fruit products produced there. 
                                Located in northern Balochistan near the Pakistan-Afghanistan border and the road across to Kandahar, Quetta is a trade and
                                 communication centre between the two countries. The city is near the Bolan Pass route which was once one of the major gateways
                                  from Central Asia to South Asia. Quetta played an important role militarily for the Pakistani Armed Forces in the intermittent Afghanistan conflict.</p>
                                     </div>
                    </div>
                </div>
            </div>
            
        </div>
    )
}

export default Quetta
